var React = require('react');

function Checklist (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m222-209.33-142-142L126.67-398l95 94.33 176-176L444.33-432 222-209.33Zm0-320-142-142L126.67-718l95 94.33 176-176L444.33-752 222-529.33Zm298 242.66v-66.66h360v66.66H520Zm0-320v-66.66h360v66.66H520Z"}));
}

Checklist.defaultProps = {"height":"40px","viewBox":"0 -750 750 750","width":"40px","fill":"#000000"};

module.exports = Checklist;

Checklist.default = Checklist;
